window.axios = require('axios');

import Vue from 'vue';
window.Vue = Vue;
require('./fontawesome');
require('./helpers/helpers');
import VModal from 'vue-js-modal';
import * as Sentry from '@sentry/browser';
import * as SentryIntegrations from '@sentry/integrations';
import { EventBus } from './events/EventBus';

if (window.App && window.App.sentryDsn) {
    Sentry.init({
        dsn: window.App.sentryDsn,
        integrations: [new SentryIntegrations.Vue({ Vue })],
        environment: process.env.MIX_APP_ENV,
    });
}

Vue.use(VModal);

window.EventBus = EventBus;

// Default map center coordinates (central Stockholm).
// Needs to be defined before Vue so it can be accessed as a data prop
window.defaultMapCenter = {
    lat: 59.3275,
    lng: 18.055,
};

document.addEventListener('DOMContentLoaded', function () {
    // Because Google Chrome don't have values on the inputs for a while,
    // we set a small timeout here.
    setTimeout(() => {
        Array.from(document.querySelectorAll('[placeholder]')).forEach(el => {
            el.classList[el.value ? 'remove' : 'add']('placeholder-shown');

            el.addEventListener('change', window.placeholderPolyfill);
            el.addEventListener('keyup', window.placeholderPolyfill);
        });
    }, 20);
});

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
